<template>
  <div>
    <v-container fluid class="pa-0 pb-8">
      <v-container class="container-custom" v-if="!newCoursesSuccess">
        <Breadcrumbs
          :title="$t('modules.courses.create.breadcrumbs.title')"
          :description="$t('modules.courses.create.breadcrumbs.description')"
        ></Breadcrumbs>
        <template>
          <v-row justify="center">
            <v-col class="viewSpaces" sm="12">
              <OutlineCard
                :title="$t('modules.courses.create.sectionData.title')"
                :subtitle="$t('modules.courses.create.sectionData.subtitle')"
                :switch-label="changeStatuslabel"
                switcher
                @switchChange="changeStatus"
                :switchValue="status"
                class="mb-6"
              >
                <v-row>
                  <v-col sm="6">
                    <v-text-field
                      :error="$v.newCourses.name.$anyError"
                      :error-messages="nameErrors"
                      outlined
                      :label="`${$t('modules.courses.create.sectionData.items.name')} *`"
                      v-model.trim="$v.newCourses.name.$model"
                      @blur="$v.newCourses.name.$touch()"
                    />
                  </v-col>
                  <v-col sm="4">
                    <v-text-field
                      :error="$v.newCourses.code.$anyError"
                      :error-messages="codeErrors"
                      :loading="checkingCode"
                      outlined
                      :label="`${$t('modules.courses.create.sectionData.items.code')} *`"
                      required
                      v-model.trim="$v.newCourses.code.$model"
                      @blur="$v.newCourses.code.$touch()"
                    />
                  </v-col>

                  <v-col sm="6">
                    <v-select
                      :error="$v.newCourses.subject.$anyError"
                      :error-messages="subjectErrors"
                      outlined
                      :items="subjects"
                      item-text="description"
                      item-value="id"
                      return-object
                      :label="`${$t('modules.courses.create.sectionData.items.subject')} *`"
                      v-model.trim="$v.newCourses.subject.$model"
                      @blur="$v.newCourses.subject.$touch()"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col sm="6">
                    <v-text-field
                      :error="$v.newCourses.legalDescription.$anyError"
                      :error-messages="legalDescriptionErrors"
                      outlined
                      :label="`${$t('modules.courses.create.sectionData.items.legalDescription')}`"
                      v-model.trim="$v.newCourses.legalDescription.$model"
                      @blur="$v.newCourses.legalDescription.$touch()"
                    />
                  </v-col>
                  <v-col sm="6">
                    <v-text-field
                      outlined
                      :label="`${$t('modules.courses.create.sectionData.items.courseSubDescription')}`"
                      v-model.trim="$v.newCourses.courseSubDescription.$model"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="6">
                    <v-checkbox v-model.trim="$v.newCourses.isPaid.$model" label="Es Pago" />
                  </v-col>
                  <v-col sm="6">
                    <v-checkbox v-model.trim="$v.newCourses.isMandatory.$model" label="Es Obligatorio" />
                  </v-col>
                </v-row>
              </OutlineCard>

              <div class="d-flex justify-end">
                <Button
                  white
                  :text="$t('actions.cancel')"
                  @end="resetButtonValues"
                  @clicked="$router.replace('/academic-courses')"
                  class="mr-4"
                />
                <Button
                  :loading="createButton.loading"
                  :success="createButton.success"
                  :error="createButton.error"
                  :text="$t('actions.create')"
                  :disabled="!canCreateCourse"
                  :successText="$t('actions.created')"
                  :errorText="'Error'"
                  @end="resetButtonValues"
                  @clicked="checkDisableAndCreate"
                ></Button>
              </div>
            </v-col>
          </v-row>
        </template>
      </v-container>
      <SuccessMessage
        v-else
        :type="successMessage.type"
        :title="successMessage.title"
        :actionPrimary="successMessage.actionPrimary"
        :actionSecondary="successMessage.actionSecondary"
      />
    </v-container>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import OutlineCard from '@/components/OutlinedCard/OutlinedCard';
import Button from '@/components/Button/Button';
import SuccessMessage from '@/components/SuccessMessage/SuccessMessage';
import { $subjects, $courses } from '../Services';
import CoursesMixin from '../Mixins';
import { mapGetters } from 'vuex';

export default {
  name: 'CoursesCreate',
  components: {
    Breadcrumbs,
    OutlineCard,
    Button,
    SuccessMessage,
  },
  mixins: [CoursesMixin],
  data() {
    return {
      subjects: [],
      loading: false,
      selectedCourseFilter: {},
      clearSelected: '',
      saving: false,
      newCourses: {
        name: null,
        code: null,
        subject: null,
        legalDescription: null,
        isPaid: false,
        isMandatory: false,
        courseSubDescription: null,
        status: true,
       // userId: null
      },
      status: true,
      createButton: {
        loading: false,
        success: false,
        error: false
      },
      successMessage: {
        title: '',
        actionPrimary: { text: 'Aceptar', callback() {} }
      },
      newCoursesSuccess: false,
    };
  },
  async mounted() {
    this.fetchSubjects();
  },
  computed: {
    ...mapGetters({
      userId: 'commons/getUserID'
    }),
  },
  methods: {
    async fetchSubjects() {
      try {
        const response = await $subjects.find(null, null, { params: { page: 0 } });
        this.subjects = response.data.content;
      } catch (e) {
        this.subjects = [];
      }
    },
    closeDrawerAlert(){
      this.$store.dispatch('commons/openPopUp', {
          title: `Estás por cerrar sin guardar los cambios`,
          content: null,
          actionPrimary: { text: 'Cerrar', callback: this.close },
          actionSecondary: { text: 'Cancelar', callback() {} },
          icon: { color: 'warning', name: 'mdi-eye-off-outline' },
          color: 'primary'
      });
    },
    changeStatus() {
      this.newCourses.status = !this.newCourses.status;
    },
    removeItems(removedItems) {
      removedItems.forEach(removedItem => {
          const index = this.selectedItems.indexOf(removedItem);
          this.selectedItems.splice(index, 1);
      })
    },
    async checkDisableAndCreate(){
      if(!this.newCourses.status)
        this.$store.dispatch('commons/openPopUp', {
        title: this.$t('modules.courses.create.disableCoursePopUp'),
        content: null,
        actionSecondary: { text: this.$t('actions.cancel'), callback() {} },
        actionPrimary: { text: this.$t('actions.create'), callback: this.createCourse },
        icon: { color: 'warning', name: 'mdi-alert' },
        color: 'primary'
        });
      else
        this.createCourse()
    },
    async createCourse() {
      if (!this.canCreate) return false
      this.createButton.loading = true;
     // this.newCourses.userId = this.userId
      try {
        await $courses.create(this.newCourses);
        this.newCoursesSuccess = true;
        this.successMessage.type = 'success';
        this.successMessage.title = this.$t('modules.courses.create.success_message.title');
        this.successMessage.actionSecondary = { text: this.$t('modules.courses.create.success_message.actions.secondary_text'), callback: () => { this.newCoursesSuccess = false } };
        if (!this.insideDrawer) {
            this.successMessage.actionPrimary = { text: this.$t('modules.courses.create.success_message.actions.primary_text'), callback: () => { this.$router.push('/academic-courses') } };
        } else {
            this.successMessage.actionPrimary = { text: this.$t('modules.courses.create.success_message.actions.primary_text'), callback: () => { this.$emit('closeDrawer'); } }
        }

        this.createButton.success = true;
        this.clearData()
      } catch (error) {
        this.newCoursesSuccess = true;
        this.successMessage.type = 'error';
        this.successMessage.title = (error.codeMeaning) ? error.codeMeaning : this.$t('modules.courses.create.error_message.title');
        this.successMessage.actionPrimary = { text: this.$t('modules.courses.create.success_message.actions.back'), callback: () => { this.newCoursesSuccess = false } }
        this.successMessage.actionSecondary = null
        this.createButton.error = true;
      } finally {
        this.resetButtonValues()
      }
    },
    resetButtonValues() {
      this.createButton.loading = false;
      this.createButton.success = false;
      this.createButton.error = false;
    },
    clearData() {
      this.selectedCourseFilter = {}
      this.clearSelected = ''
      this.newCourses = {
        name: null,
        code: null,
        subject: null,
        legalDescription: null,
        isPaid: false,
        isMandatory: false,
        courseSubDescription: null,
        status: true,
    //    userId: null
    },
      this.status = true
      this.$v.$reset()
      this.resetButtonValues()
    }
  }
};
</script>
